import { PaneItem } from '@/components/pane/types';

export const modelRegistrationConfig: PaneItem[] = [
  {
    icon: require('../public/static/images/tensorflow-logo.png'),
    label: 'Tensorflow',
    language: 'python',
    codeSnippet: `with exa.ModuleRepository("repo") as repo:
    uid = repo.register_tf_savedmodel(
        "TFModel:v1.0",
        "/tf_model.savedmodel",
    )
    print(uid)
    # -> @jsGUAJrNjwp9I9sc7uPR`,
  },
  {
    icon: require('../public/static/images/pytorch-logo.png'),
    label: 'PyTorch',
    language: 'python',
    codeSnippet: `with exa.ModuleRepository("repo") as repo:
    uid = repo.register_torchscript(
        "PTModel:v1.0",
        "/pytorch_model.pt",
    )
    print(uid)
    # -> @47DEQpj8HBSa-_TImW-5`,
  },
  {
    icon: require('../public/static/images/onnx-logo.png'),
    label: 'ONNX',
    language: 'python',
    codeSnippet: `with exa.ModuleRepository("repo") as repo:
    uid = repo.register_onnx(
        "ONNXModel:v1.0",
        "/onnx_model.onnx",
    )
    print(uid)
    # -> @ER12z80S2mPe_Pd1NVsT`,
  },
  {
    icon: require('../public/static/images/tensorrt-logo.png'),
    label: 'TensorRT',
    language: 'python',
    codeSnippet: `with exa.ModuleRepository("repo") as repo:
    uid = repo.register_tensorrt_engine(
        "TensorRTEngine:v1.0",
        "/tensorrt.engine",
    )
    print(uid)
    # -> @EVAEx4zfQyv7pRLj1FUj`,
  },
];
